/**
 * Twee beslissingen van het checklistscherm (`app-checklists-page.tsx`), los gehaald zodat ze zonder
 * scherm te testen zijn.
 */

/** Wat deze regels van een item nodig hebben: of het verplicht is, en of het al ingevuld is. */
export interface FinishState {
  item: { required: boolean };
  done: boolean;
}

/**
 * Mag de knop **Checklist afronden** verschijnen?
 *
 * Zodra elk **verplicht** item ingevuld is - dezelfde regel als de server (`remainingRequired`,
 * `POST /me/checklists/:runId/complete` weigert alleen met open verplichte items). Tot het
 * testrapport van 28 okt. 2026 wachtte de knop op élk item, ook een optioneel foto-item: wie geen
 * foto kon nemen (offline, of geen reden voor een foto), kon de ronde dan niet afronden, terwijl
 * de server het wel toeliet.
 */
export function readyToFinish(states: FinishState[]): boolean {
  return states.every((state) => state.done || !state.item.required);
}

/**
 * Waarom deze checklist alleen te bekijken is, voor de melding bovenaan.
 *
 * Een afgeronde ronde is voor iedereen alleen te bekijken, ook voor de ploeg die ze afvinkte; daar
 * "Hij is toegewezen aan je eigen ploeg" bij zetten, klopt dan niet (testrapport 28 okt. 2026).
 */
export function readOnlyReason(run: { status: string }): 'completed' | 'notYours' {
  return run.status === 'completed' ? 'completed' : 'notYours';
}
